"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const styles_1 = require("@material-ui/core/styles");
const _ = require("lodash");
const react_i18next_1 = require("react-i18next");
const react_slick_1 = require("react-slick");
const FeaturedCard_1 = require("../card/FeaturedCard");
const assets_1 = require("../config/assets");
const config_1 = require("../config/config");
const RewardsScreenStyle_1 = require("./jss/RewardsScreenStyle");
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false
};
const FeaturedRewardHeader = ({ featuredRewards, classes, onRewardSelect, t }) => {
    const sortedFeaturedRewards = _.orderBy(featuredRewards, 'date_start', 'desc');
    return sortedFeaturedRewards && sortedFeaturedRewards.length > 0 ? ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, className: classes.carouselContainer }, { children: (0, jsx_runtime_1.jsx)(react_slick_1.default, Object.assign({}, settings, { className: classes.rewardHeader }, { children: sortedFeaturedRewards.map(featuredReward => {
                const onPress = () => {
                    onRewardSelect(featuredReward);
                };
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, item: true, xs: 12, alignItems: 'flex-start', justify: 'flex-start' }, { children: (0, jsx_runtime_1.jsx)(FeaturedCard_1.default, { onButtonClick: onPress, buttonText: "Redeem", image: featuredReward.image, imageTitle: config_1.config.internalConfig.SHOW_IMAGE_PREFIX ? 'Image of game ' + featuredReward.title : featuredReward.title, title: `${t('rewards.redeemFor')}: ${featuredReward.num_points.toPointsFormatWithUnit()}`, text: featuredReward.title, textDescription: featuredReward.description, textFooter: `${t('rewards.redeemFor')}: ${featuredReward.num_points.toPointsFormatWithLowerCaseUnit()}`, iconFooter: config_1.config.internalConfig.REWARDS_ICON, noImageAsset: assets_1.assets.internalAssets.noFeaturedImg }) })) }, featuredReward.id));
            }) })) }))) : null;
};
exports.default = (0, styles_1.withStyles)(RewardsScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(FeaturedRewardHeader));
//# sourceMappingURL=FeaturedRewardHeader.js.map